module.exports = __webpack_public_path__ + "static/abbadook-668a652c26da5455a7d93ad901ebe991.jpg";